import {
  DAILY_REMAINING_BUDGET,
  DAILY_REMAINING_TARGET,
  DAILY_BUDGET_DEPLETION,
  DAILY_TARGET_DEPLETION,
  DAILY_BUDGET,
  DAILY_TARGET,
  CONVERSION_VALUE,
  SPEND
} from './constants'

const BUDGET_AND_TARGET_FIELDS_AND_RELATED_METRICS = [
  DAILY_BUDGET,
  DAILY_TARGET,
  DAILY_REMAINING_BUDGET,
  DAILY_REMAINING_TARGET,
  DAILY_BUDGET_DEPLETION,
  DAILY_TARGET_DEPLETION
]

const BUDGET_AND_TARGET_FIELDS_AND_RELATED_METRICS_SET = new Set(BUDGET_AND_TARGET_FIELDS_AND_RELATED_METRICS)

const BUDGET_AND_TARGET_FIELDS: Record<string, { relatedMetric: string }> = {
  [DAILY_TARGET]: { relatedMetric: CONVERSION_VALUE },
  [DAILY_BUDGET]: { relatedMetric: SPEND }
}

/***
 * Get the corresponding budget field from the related metric
 * e.g. SPEND is related to DAILY_BUDGET and CONVERSION_VALUE is related to DAILY_TARGET
 */
export const getBudgetFieldFromRelatedMetric = (relatedMetric: string): string | null => {
  const budgetField = Object.keys(BUDGET_AND_TARGET_FIELDS).find(
    (field) => BUDGET_AND_TARGET_FIELDS[field].relatedMetric === relatedMetric
  )
  return budgetField ?? null
}

/***
 * Check if the metric is a budget metric, otherwuise will return false
 */
export const isBudgetMetric = (metric: string): boolean => {
  return BUDGET_AND_TARGET_FIELDS_AND_RELATED_METRICS_SET.has(metric)
}
